<div class="main_body">
  <app-page-header
    [title]="toolbarTitle"
    [backLabel]="backLabel"
    [backIcon]="backIcon"
    [backRoute]="backRoute"
    icon="staff"
  />
  <div class="contents">
    <div class="contents_section_group">
      <section class="contents__section">
        <div class="form-container">
          <!-- Staff Type Indicator -->
          <div class="form-section">
            <div class="form-label">
              <span class="form-label__text" i18n="@@adminSection.staffInvitation.label.staffType">招待種別</span>
            </div>
            <div class="staff-type-indicator">
              <div class="staff-type-indicator__item"
                   [class.staff-type-indicator__item--active]="userType === 'STAFF'">
                <mat-icon class="staff-type-indicator__icon">shield</mat-icon>
                <span class="staff-type-indicator__label" i18n="@@adminSection.staffInvitation.type.staff">スタッフ</span>
                @if (userType === 'STAFF') {
                  <mat-icon class="staff-type-indicator__check">check_circle</mat-icon>
                }
              </div>
              <div class="staff-type-indicator__item"
                   [class.staff-type-indicator__item--active]="userType === 'CONTRIBUTOR'">
                <mat-icon class="staff-type-indicator__icon">person</mat-icon>
                <span class="staff-type-indicator__label" i18n="@@adminSection.staffInvitation.type.contributor">多職種スタッフ</span>
                @if (userType === 'CONTRIBUTOR') {
                  <mat-icon class="staff-type-indicator__check">check_circle</mat-icon>
                }
              </div>
            </div>
            <p class="form-hint">
              @if (userType === 'STAFF') {
                <span i18n="@@adminSection.staffInvitation.hint.staff">スタッフは管理権限の付与が可能です</span>
              } @else {
                <span i18n="@@adminSection.staffInvitation.hint.contributor">多職種スタッフはデータ入力・記録・閲覧が可能です</span>
              }
            </p>
          </div>

          <div class="form-divider"></div>

          <!-- Email Section -->
          <div class="form-section">
            <div class="form-label">
              <span class="form-label__text" i18n="@@adminSection.staffInvitation.label.email">メールアドレス</span>
              <span class="form-label__required">*</span>
            </div>
            <mat-form-field appearance="outline" class="form-field">
              <input matInput
                     type="email"
                     [formControl]="email"
                     placeholder="例: staff@example.com"
                     i18n-placeholder="@@adminSection.staffInvitation.placeholder.email" />
              <mat-icon matSuffix class="material-icons-outlined">mail</mat-icon>
              @if (email.hasError('required')) {
                <mat-error i18n="@@adminSection.staffInvitation.error.emailRequired">メールアドレスは必須です</mat-error>
              } @else if (email.hasError('email')) {
                <mat-error i18n="@@adminSection.staffInvitation.error.emailInvalid">有効なメールアドレスを入力してください</mat-error>
              }
            </mat-form-field>
            <p class="form-hint" i18n="@@adminSection.staffInvitation.hint.email">招待メールがこのアドレスに送信されます</p>
          </div>

          <!-- Job Title Section -->
          <div class="form-section">
            <div class="form-label">
              <span class="form-label__text" i18n="@@adminSection.staffInvitation.label.jobTitle">職種</span>
              <span class="form-label__required">*</span>
            </div>
            <mat-form-field appearance="outline" class="form-field">
              <mat-select [(value)]="jobTitle" [placeholder]="i18n.placeholder.jobTitle">
                @for (job of common.staffJobTitles; track job.code) {
                  <mat-option [value]="job.desc">{{ job.desc }}</mat-option>
                }
              </mat-select>
              <mat-icon matSuffix class="material-icons-outlined">work</mat-icon>
            </mat-form-field>
            <p class="form-hint" i18n="@@adminSection.staffInvitation.hint.jobTitle">招待するスタッフの職種を選択してください</p>
          </div>

          <div class="form-divider"></div>

          <!-- User Assignment (Contributors only) -->
          @if (userType === 'CONTRIBUTOR') {
            <div class="form-section">
              <div class="form-label">
                <span class="form-label__text" i18n="@@adminSection.staffInvitation.label.userAssignment">担当ユーザー</span>
                <span class="form-label__optional">{{ i18n.label.optional }}</span>
              </div>
              @if (isLoadingUsers()) {
                <!-- Skeleton for user select -->
                <div class="form-field-skeleton">
                  <div class="skeleton skeleton--field"></div>
                </div>
              } @else {
                <mat-form-field appearance="outline" class="form-field">
                  <mat-select [(ngModel)]="selectedUser" [placeholder]="i18n.placeholder.noUser">
                    <mat-option>
                      <ngx-mat-select-search
                        [formControl]="userSearchCtrl"
                        placeholderLabel="ユーザーを検索..."
                        noEntriesFoundLabel="該当するユーザーがいません"
                        i18n-placeholderLabel="@@adminSection.staffInvitation.placeholder.searchUser"
                        i18n-noEntriesFoundLabel="@@adminSection.staffInvitation.label.noUserFound">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option [value]="null">{{ i18n.option.noUser }}</mat-option>
                    @for (user of filteredUsers(); track user.user.userId) {
                      <mat-option [value]="user.user.userId">
                        {{ user.user.code ? user.user.code : (user.user.lastName + ' ' + user.user.firstName) }}
                      </mat-option>
                    }
                  </mat-select>
                  <mat-icon matSuffix class="material-icons-outlined">person</mat-icon>
                </mat-form-field>
              }
              <p class="form-hint" i18n="@@adminSection.staffInvitation.hint.userAssignment">この{{ userTypeDisp }}を割り当てるユーザーを指定できます</p>
            </div>
          }

          <!-- Role Permissions (Staff only) -->
          @if (userType !== 'CONTRIBUTOR') {
            <div class="form-section">
              <div class="form-label">
                <span class="form-label__text" i18n="@@adminSection.staffInvitation.label.permissions">管理権限</span>
                <span class="form-label__optional">{{ i18n.label.optional }}</span>
              </div>
              <div class="role-checkboxes">
                <label class="role-checkbox">
                  <mat-checkbox [(ngModel)]="accountManageRole" name="accountManageRole" color="primary"></mat-checkbox>
                  <div class="role-checkbox__content">
                    <span class="role-checkbox__label" i18n="@@adminSection.staffInvitation.label.accountManagement">スタッフ管理</span>
                    <span class="role-checkbox__description">{{ i18n.description.accountManagement }}</span>
                  </div>
                </label>
                <label class="role-checkbox">
                  <mat-checkbox [(ngModel)]="userManageRole" name="userManageRole" color="primary"></mat-checkbox>
                  <div class="role-checkbox__content">
                    <span class="role-checkbox__label" i18n="@@adminSection.staffInvitation.label.userManagement">ユーザー管理</span>
                    <span class="role-checkbox__description">{{ i18n.description.userManagement }}</span>
                  </div>
                </label>
              </div>
            </div>
          }

          <!-- Form Actions -->
          <div class="form-actions">
            <button mat-stroked-button
                    (click)="resetFields()">
              <mat-icon>refresh</mat-icon>
              <span i18n="@@adminSection.staffInvitation.button.clearForm">クリア</span>
            </button>
            <button mat-flat-button
                    color="primary"
                    [disabled]="email.invalid || !jobTitle || isSending()"
                    (click)="invite()">
              @if (isSending()) {
                <mat-spinner diameter="18"></mat-spinner>
              }
              <span i18n="@@adminSection.staffInvitation.button.sendInvitation">招待を送信</span>
            </button>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
